import { operatorApiFetch } from './apiService';

export const merchantService = {
  // 列表
  getRecords: async (params) => {
    const response = await operatorApiFetch('merchants/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('merchants/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取單個貨主
  get: async (id) => {
    const response = await operatorApiFetch(`merchants/${id}`, {
      method: 'GET'
    });
    return response.json();
  },

  // 分頁列表（支援 since_id, page_size, search）
  getList: async (params = {}) => {
    const response = await operatorApiFetch('merchants', {
      method: 'GET',
      params,
    });
    return response.json();
  },

  getCurrentOrganizationMerchants: async (params = {}) => {
    const response = await operatorApiFetch('organizations/current/merchants', {
      method: 'GET',
      params,
    });
    return response.json();
  },

  create: async (data) => {
    const { user, ...merchantData } = data;
    const body = { merchant: merchantData };
    if (user) body.user = user;
    const response = await operatorApiFetch('merchants', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return response.json();
  },

  // scope: 'invitable' → 只回 inviter 個人 SAM 範圍（鏡像 BE invitation guard），
  // 避免邀請 modal 顯示「能勾但送出 403」的清單。其他 caller（盤點移倉等）不傳 scope
  // 仍維持原本「warehouse 全 list」行為。
  listAllWarehouseMerchants: async ({ page = 1, pageSize, keyword, scope, warehouseId } = {}) => {
    const params = { page };
    if (pageSize) params.page_size = pageSize;
    if (keyword) params.keyword = keyword;
    if (scope) params.scope = scope;
    if (warehouseId) params.warehouse_id = warehouseId;
    const response = await operatorApiFetch('warehouses/list_all_merchants', {
      method: 'GET',
      params,
    });
    return response.json();
  },

  // 取得所有 warehouse merchants（自動分頁載入全部）
  fetchAllWarehouseMerchants: async ({ keyword, scope } = {}) => {
    let allData = [];
    let page = 1;
    let hasMore = true;
    while (hasMore) {
      const res = await merchantService.listAllWarehouseMerchants({ page, keyword, scope });
      if (res.success && res.data) {
        allData = [...allData, ...res.data];
        hasMore = res.has_more || false;
      } else {
        break;
      }
      page++;
    }
    return { success: true, data: allData };
  },

  getWarehouseMerchantIds: async ({ keyword, scope, warehouseId } = {}) => {
    const params = {};
    if (keyword) params.keyword = keyword;
    if (scope) params.scope = scope;
    if (warehouseId) params.warehouse_id = warehouseId;
    const response = await operatorApiFetch('warehouses/merchant_ids', {
      method: 'GET',
      params,
    });
    return response.json();
  },

  // 獲取所有貨主（不分頁，僅 ID 和 Name）
  listAll: async () => {
    const response = await operatorApiFetch('merchants/list_all', {
      method: 'GET'
    });
    return response.json();
  },

  // 更新訂單項目欄位設定
  updateOrderItemColumns: async (merchantId, columns) => {
    const response = await operatorApiFetch('merchants/update_order_item_columns', {
      method: 'PATCH',
      body: JSON.stringify({ merchant_id: merchantId, columns })
    });
    return response.json();
  }
};
export default merchantService;
